module.exports = __webpack_public_path__ + "img/ltku-1x.ff7b745.jpg";